const csSingle = (gsap, mm, ScrollTrigger, smoother, ScrambleTextPlugin, Swiper, FreeMode, Parallax, Navigation, Pagination) => {
	
	/***************************************************************
		PARALLAX ITEMS
	***************************************************************/
 
	const $goals = $('.cs-goals-copy');
	const $goalsImg = $('.cs-goals .rgb');
	//const $statTexts = $('.stat-text');
	//const $stat2 = $('.stat2');
	//const $stat3 = $('.stat3');
		
	mm.add("(min-width: 768px)", () => {

		if ($goals) {
			smoother.effects($goals, {speed: 0.95});
			smoother.effects($goalsImg, {speed: 1.25});
		}
				
		//if ($stat2) {
		//	smoother.effects($stat2, {lag: 0.5});
		//}
		
		//if ($stat3) {
		//	smoother.effects($stat3, {lag: 1.25});
		//}
				
	}, '.single-case-studies');
	
	/***************************************************************
		CS STATS ANIMATION
	***************************************************************/
 
	//if ($statTexts) {
		
	//	$statTexts.each(function() {
			
	//		const $this = $(this);
	//		const $text = $this.text();
			
	//		gsap.to($this, {
	//			scrambleText: {
	//				text: $text,
	//				chars: "#$@",
	//				revealDelay:1,
	//				tweenLength:false,
	//			}
	//		})
			
	//		gsap.to($this, {
	//			scrollTrigger: {
	//				trigger: ".cs-results",
	//				start: "top center",
	//			},
	//			scrambleText:{
	//				text: $text, 
	//				chars:"#$@", 
	//				speed:0.4
	//			},
	//			onStart: function() {
	//				$this.addClass('tweening');
	//			},
	//			onComplete: function() {
	//				$this.removeClass('tweening');
	//			}
	//		});
			
	//	});
		
	//}
		
	//ScrollTrigger.kill();

}

export {
	csSingle
};
